<template>
  <el-card body-style="padding:0px" shadow="never">
    <div class="pic-analyse-header">
      <div class="flex align-center">
        <i class="el-icon-search mr10" style="font-size:20px"></i>
        <span class="mr10" style="font-size:20px">人才画像分析</span> <span style="color: #ff0000;">NEW</span>
      </div>
      <div style="cursor:pointer" @click="showDetail = !showDetail">
        <span class="mr10">{{ showDetail ? '收起' : '展示' }}详情</span>
        <i
          class="el-icon-arrow-down"
          :style="`transition: auto .5s ease;transform: rotateZ(${showDetail ? '180' : '0'}deg);`"
        ></i>
      </div>
    </div>
    <div v-show="showDetail">
      <div class="flex flex-wrap" style="padding: 10px 10px 0;">
        <!-- <el-button
          v-if="project.典型人才 && project.典型人才.length > 0"
          class="mr10 mb10"
          size="mini"
          :type="activeType === '典型人才' ? 'primary' : ''"
          plain
          @click="activeType = '典型人才'"
          >典型人才画像（客户指定人选）</el-button
        > -->
        <el-button
          v-for="item in tableTypes"
          :key="item.type"
          class="mr10 mb10"
          size="mini"
          :type="activeType === item.type ? 'primary' : ''"
          plain
          @click="activeType = item.type"
          >{{ item.label }}</el-button
        >
      </div>
      <p class="field-alert" style="padding-left: 10px;padding-right: 10px;">{{ alert[activeType] }}</p>
      <table class="pic-analyse-table">
        <tr v-for="(tr, index) in tableFields" :key="`tableTr${index}`">
          <td v-for="(td, tdIndex) in tr.children" :key="`tr${index}td${tdIndex}${td.label}`">
            <el-tooltip v-if="td.label" :content="labelTooltip[td.label]" placement="top">
              <p class="analyse-td-label">{{ td.label }}：</p>
            </el-tooltip>
            <el-tooltip
              v-if="Array.isArray(analyse[td.field])&&activeType==='目标画像'"
              :disabled="Array.isArray(analyse[td.field]) && analyse[td.field].length === 0"
              placement="top"
            >
              <div slot="content">
                <p v-for="i in analyse[td.field]" :key="i">{{ i }}</p>
                <!-- 多行信息<br/>第二行信息 -->
              </div>
              <p :id="`tr${index}td${tdIndex}${td.label}`" class="analyse-td-content">
                {{ Array.isArray(analyse[td.field]) ? analyse[td.field][0] || '--' : analyse[td.field] || '--' }}
              </p>
            </el-tooltip>
            <p v-else-if="Array.isArray(analyse[td.field])&&activeType!=='目标画像'" :id="`tr${index}td${tdIndex}${td.label}`" class="analyse-td-content" @click="getChart(td.label,analyse[td.field],`tr${index}td${tdIndex}${td.label}`)">
              {{ Array.isArray(analyse[td.field]) ? analyse[td.field][0] || '--' : analyse[td.field] || '--' }}
            </p>
            <p v-else-if="td.label" class="analyse-td-content">{{ analyse[td.field] || '--' }}</p>
            <!-- <p v-if="td.label" class="analyse-td-content">{{ analyse[td.field] || '--' }}</p> -->
          </td>
        </tr>
      </table>
    </div>

    <!-- popper -->
    <Popper
      :id="`radishAnalyse${project._id}`"
      :visible.sync="popperVisible"
      style="z-index: 31;"
      :target-id="popperTarget"
      container="projectTableWrapper"
    >
      <div class="radish-analyse-popper">
        <p class="popper-title">{{ popperDetail.title }}</p>
        <div class="chart-box">
          <div id="popper-dom"></div>
          <div class="right-box">
            <div class="detail-title">各{{ popperDetail.type }}比例</div>
            <div class="detail-content-box">
              <div class="detail-content radish-analyse-bottom-line" style="color:#919191;">
                <div class="detail-content-item">{{ popperDetail.type }}</div>
                <div class="detail-content-item">比例</div>
              </div>
              <div v-for="item in popperDetail.data" :key="item.label" class="detail-content">
                <div class="detail-content-item">{{ item.label }}</div>
                <div class="detail-content-item">{{ item.value }}%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popper>
  </el-card>
</template>
<script>
import Popper from "../Popper"

import { defaultProject, defaultCompany } from '../../constant/defaultData'
import { tags } from '../../constant/type'

const echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/bar')

const dateFormat = require('dateformat')

export default {
  components:{ Popper },
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
  },
  data() {
    return {
      hasLogo: false,
      contract: {},
      showDetail: false,
      activeType: '目标画像',
      // tableTypes: [
      //   // {type:'典型人才',label:'典型人才画像（客户指定人选）',},
      //   { type: '目标画像', label: '岗位目标画像' },
      //   { type: '简历', label: '通过简历筛选人才' },
      //   { type: '同职能', label: '客户公司现有同职能人员画像' },
      //   { type: '所有人员', label: '客户公司所有人员画像' },
      // ],
      popperVisible: false,
      popperTarget: null,
      popperDetail:{
        title:'',
        type:'',
        data: [],
      },
      alert: {
        典型人才: '此数据基于典型人才得出',
        目标画像: '此数据基于岗位要求得出',
        简历: '此数据基于简历得出',
        同职能: '此数据基于该公司现有同职能人员得出',
        所有人员: '此数据基于该公司现有人员得出',
      },
      tableFields: [
        {
          children: [
            { label: '地域', field: '地域' },
            { label: '性别', field: '性别' },
            { label: '年龄', field: '年龄' },
            { label: '学历要求', field: '学历要求' },
            { label: '学历标签', field: '学历标签' },
            { label: '工作经验', field: '工作经验' },
          ],
        },
        {
          children: [
            { label: '业绩', field: '业绩' },
            { label: '稳定性', field: '稳定性' },
            { label: '来源公司', field: '来源公司' },
            { label: '来源行业', field: '来源行业' },
            { label: '平台', field: '平台' },
            { label: '', field: '' },
          ],
        },
        {
          children: [
            { label: '专业能力', field: '专业能力' },
            { label: '语言能力', field: '语言能力' },
            { label: '领导能力', field: '领导能力' },
            { label: '心态/性格', field: '心态/性格' },
            { label: '个人风格', field: '个人风格' },
            { label: '', field: '' },
          ],
        },
      ],
      labelTooltip:{
        地域:'人员所在地域',
        性别:'人员性别统计',
        年龄:'人员平均年龄（5年一分类）',
        学历要求:'人员平均学历分布',
        学历标签:'人员学历标签分布',
        工作经验:'人员工作年限统计',
        业绩:'人员各业绩统计',
        稳定性:'公司人员稳定性统计',
        来源公司:'人员来源比例统计',
        来源行业:'人员来源行业比例统计',
        平台:'人员来源平台比例统计',
        专业能力:'人员各专业能力的比例',
        语言能力:'人员各语言能力的比例',
        领导能力:'人员各领导能力比例',
        '心态/性格':'人员各心态/性格标签的比例',
        个人风格:'人员个人风格比例',
      },
      analyse: {},
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
    tableTypes() {
      const arr = []
      if (this.project.典型人才 && this.project.典型人才.length > 0) {
        arr.push({ type: '典型人才', label: '典型人才画像（客户指定人选）' })
      }
      arr.push({ type: '目标画像', label: '岗位目标画像' })
      if (this.project.interviews && this.project.interviews.length > 0) {
        arr.push({ type: '简历', label: '通过简历筛选人才' })
      }
      if (this.project.客户公司 && this.project.职能模块) {
        arr.push({ type: '同职能', label: '客户公司现有同职能人员画像' })
      }
      if (this.project.客户公司) {
        arr.push({ type: '所有人员', label: '客户公司所有人员画像' })
      }
      return arr
    },
    tags() {
      const obj = {}
      tags.forEach(tag => {
        obj[tag.label] = tag.children
      })
      return obj
    },
  },
  watch: {
    company: {
      handler(newValue, oldValue) {
        if (this.company._id) this.init()
      },
      immediate: true,
    },
    activeType(newValue, oldValue) {
      this.getCount()
    },
  },
  mounted() {
    const fields = []
    const { tableFields } = this
    tableFields.forEach(tr => {
      tr.children.forEach(td => {
        if (td.label) fields.push(td.field)
      })
    })
    this.analyseFields = fields
  },
  methods: {
    init() {
      this.hasLogo = this.company && this.company.checkdata && this.company.checkdata.ImageUrl
      if (this.company.companyAttachments && this.company.companyAttachments.length > 0) {
        this.company.companyAttachments.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0))
      }
      this.contract = (this.company.companyAttachments || []).find(v => v.type === '合同') || {}
      this.getCount()
    },
    async getCount() {
      const { activeType } = this
      if (activeType === '典型人才') {
        const rids = this.project.典型人才 || []
        const setRids = [...new Set(rids)]
        this.getRadishImage(setRids)
      } else if (activeType === '目标画像') {
        this.getProjectImage()
      } else if (activeType === '简历') {
        const rids = this.project.interviews.map(v => v.rid)
        const setRids = [...new Set(rids)]
        this.getRadishImage(setRids)
      } else if (activeType === '同职能') {
        this.getCompanyRadishImageCate()
      } else if (activeType === '所有人员') {
        this.getCompanyRadishImage()
      }
      // this.analyse = {}
      // const res = await app.service('company').companyHistoryCount(this.company._id)
      // if(res.status==='success') this.analyse = res.data
      // else this.$message.error(res.msg)
    },
    getProjectImage() {
      const projectImageMap = {
        地域: '地域',
        性别: '性别',
        年龄: '年龄要求',
        学历要求: '学历要求',
        学历标签: '倾向学历',
        工作经验: '工作经验',
        业绩: '业绩',
        稳定性: '稳定性',
        来源公司: '目标公司',
        来源行业: '目标行业',
        平台: '平台',
        专业能力: '标签',
        语言能力: '标签',
        领导能力: '标签',
        '心态/性格': '标签',
        个人风格: '标签',
      }
      const tagTranslate = {
        '心态/性格': '心态、个性',
        领导能力: '领导',
        专业能力: '专业因素',
      }
      const obj = {}
      this.analyseFields.forEach(v => {
        const field = projectImageMap[v]
        if (v === '年龄') {
          const arr = (this.project['年龄要求'] || []).filter(a => a)
          obj[v] = arr.length > 0 ? `${arr.join('-')}岁` : ''
        } else if (field === '标签') {
          const arr = (this.project['标签'] || []).filter(a => (this.tags[tagTranslate[v] || v] || []).includes(a))
          obj[v] = arr
        } else {
          obj[v] = this.project[field]
        }
      })
      this.analyse = obj
    },
    async getRadishImage(setRids) {
      const res = await app.service('project').getRadishImage(setRids)
      if (res.status === 'success') {
        const radishImage = res.data || {}
        const obj = {}
        const echartObj = {}
        this.analyseFields.forEach(v => {
          obj[v] = this.radishImageTemplate(radishImage, v)
          echartObj[v] = this.getDistribution(radishImage, v)
        })
        this.analyse = obj
        this.echartObj = echartObj
      }
    },
    async getCompanyRadishImageCate() {
      const option = { cid: this.company._id, cate: this.project.职能模块 }
      const res = await app.service('company').getCompanyStatistics(option)
      if (res.status === 'success') {
        const radishImage = (res.data && res.data[0]) || {}
        const obj = {}
        const echartObj = {}
        this.analyseFields.forEach(v => {
          obj[v] = this.radishImageTemplate(radishImage, v)
          echartObj[v] = this.getDistribution(radishImage, v)
        })
        this.analyse = obj
        this.echartObj = echartObj
      }
    },
    async getCompanyRadishImage() {
      const option = { cid: this.company._id }
      const res = await app.service('company').getCompanyStatistics(option)
      if (res.status === 'success') {
        const radishImage = (res.data && res.data[0]) || {}
        const obj = {}
        const echartObj = {}
        this.analyseFields.forEach(v => {
          obj[v] = this.radishImageTemplate(radishImage, v)
          echartObj[v] = this.getDistribution(radishImage, v)
        })
        this.analyse = obj
        this.echartObj = echartObj
      }
    },
    getDistribution(radishImage, item){
      const val = radishImage[item]
      if (!val || !val['统计']) return []
      const arr = val['统计'].filter(v => v[0] !== '未知').slice(0, 10)
      if (arr.length > 0) {
        return arr.filter(a=>((a[2] * 100).toFixed(1))!=='0.0').map(a => ({ label:a[0], value:(a[2] * 100).toFixed(1) }))
      } else return []
    },
    radishImageTemplate(radishImage, item) {
      const val = radishImage[item]
      if (!val || !val['统计']) return ''
      const arr = val['统计'].filter(v => v[0] !== '未知').slice(0, 10)
      if (arr.length > 0) {
        return arr.map(a => `${a[0]}（${(a[2] * 100).toFixed(1)}%）`)
      } else return ''
    },
    getChart(type,fields,targetId){
      const { echartObj } = this
      const arr = echartObj[type]
      if(!arr || arr.length===0) return this.$message.error('该类别没有数据')
      if(this.activeType==='目标画像') return

      this.popperVisible = false
      this.popperVisible = true
      this.popperTarget = targetId


      const popperDetail = {
        title:`该公司员工${type}统计`,
        type:type,
        data: [],
      }

      arr.sort((a,b)=>b.value-a.value)
      let option
      if(type==='性别'){
        option = {
          tooltip: {
            trigger: 'item',
            formatter: function(param) {
              const value = param.data
              return `${value.name}：${value.value}%`
            },
          },
          series: [
            {
              // name: '访问来源',
              type: 'pie',
              radius: '55%',
              center: ['50%', '60%'],
              emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
            }
          ]
        };
        const genderArr = arr.filter(v=>['男','女'].includes(v.label))
        const other = {label:'未知',value:100-(genderArr[0]&&genderArr[0].value ||0)-(genderArr[1]&&genderArr[1].value ||0)}
        other.value = other.value.toFixed(1)
        genderArr.push(other)
        option.series[0].data = genderArr.map(v=>({name:v.label,value:parseFloat(v.value)}))
        popperDetail.data = genderArr
        this.$nextTick(_ => {
          const myChart = echarts.init(this.$el.querySelector('#popper-dom'))
          myChart.setOption(option,true)
        })
      }else {
        option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: function(params) {
              const param = params[0]
              return `${param.name}：${param.value}%`
            },
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            axisTick: {
              alignWithLabel: true
            }
          },
          yAxis: {
            type: 'value',
          },
          series: [{
            name: '比例',
            type: 'bar',
            barWidth: '60%',
            // tooltip: {
            //   formatter: function(param) {
            //     const value = param.data
            //     return `${value.name}：${value.value}%`
            //   },
            // },
          }]
        }
        option.xAxis.data = arr.map(v=>v.label)
        option.series[0].data = arr.map(v=>parseFloat(v.value))
        popperDetail.data = arr
        this.$nextTick(_ => {
          const myChart = echarts.init(this.$el.querySelector('#popper-dom'))
          myChart.setOption(option,true)
        })
      }
      this.popperDetail = popperDetail
    },
  },
}
</script>
<style scoped src="../../css/newProjectDetail.css"></style>
<style scoped>
.company-tag {
  font-size: 14px;
  text-align: center;
  cursor: pointer;
  margin-right: 10px;
}
.pic-analyse-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #5aa2ea;
  padding: 10px;
  color: #fff;
}

.pic-analyse-table {
  width: 100%;
}
.pic-analyse-table td {
  width: 16%;
  padding: 5px 10px;
}
.pic-analyse-table .analyse-td-label {
  text-align: left;
  margin-bottom: 10px;
  color: #9f9f9f;
}
.pic-analyse-table .analyse-td-content {
  /* width: 16%; */
}
.radish-analyse-popper {
  padding: 10px 20px;
  border: 1px solid #eaeefb;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.popper-title {
  font-size: 18px;
  text-align: left;
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 8px;
}
.chart-box{
  display: flex;
  align-items: flex-end;
}
#popper-dom{
  width: 300px;
  height: 300px;
}
.right-box{
  width: 200px;
  padding-top: 10px;
}
.detail-title {
  background-color: #919191;
  padding: 6px;
  border-radius: 4px;
  text-align: center;
  color: #fff;
}
.detail-content {
  display: flex;
  padding: 2px;
}
.detail-content-item {
  width: 50%;
  text-align: center;
}
.radish-analyse-bottom-line{
  border-bottom: 1px solid #eee;
}
.analyse-td-content-item{
  border:1px solid #eee;
  padding: 6px 10px;
}
.detail-content-box{
  border: 1px solid #eee;
}
</style>
